export class DropDownModel {
  value: number;
  display: string;
  enumValue?: number;
  constructor(data?) {
    if (data) {
      this.value = data.value;
      this.display = data.display;
      this.enumValue = data.enumValue;
    }
  }
}

export class DropDownHideItemModel extends DropDownModel {
  selected: boolean = false;
  constructor(data) {
    super(data);
    this.selected = data.selected;
  }
}
